export default __webpack_public_path__ + "locales/zh-CN/Translations.json?hash=6c2d8bb26d6b9687928293c14d34cf89";